/**
 * Scorre la finestra fino a un elemento DOM referenziato, con opzioni e un offset.
 * @param {React.RefObject} elementRef - Ref dell'elemento React a cui scrollare.
 * @param {object} options - Opzioni per scrollIntoView e offset.
 * @param {string} options.behavior - 'smooth' o 'auto'. Default 'smooth'.
 * @param {string} options.block - 'start', 'center', 'end', 'nearest'. Default 'start'.
 * @param {string} options.inline - 'start', 'center', 'end', 'nearest'. Default 'nearest'.
 * @param {number} options.offset - Offset verticale in pixel (negativo per scrollare un po' sopra). Default -20.
 */

/**
 * Scorre la finestra fino a un elemento DOM, con comportamento e posizione predefiniti.
 * @param {HTMLElement} element - L'elemento DOM a cui scrollare.
 */
export const scrollToElementDefault = (element) => {
  if (element && typeof element.scrollIntoView === 'function') {
    // Ritarda leggermente lo scroll per assicurarsi che l'elemento sia completamente renderizzato e visibile
    requestAnimationFrame(() => {
      try {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center', // Cerca di posizionare l'elemento al centro della viewport
          inline: 'nearest'
        });

      } catch (e) {

      }
    });
  } else {
    // Element reference invalid or scrollIntoView not available
  }
};

/**
 * Evidenzia temporaneamente un elemento DOM.
 * @param {HTMLElement} element - L'elemento DOM da evidenziare.
 * @param {string} highlightColor - Colore per l'highlight (es. 'rgba(59, 130, 246, 0.2)').
 * @param {number} duration - Durata totale dell'highlight in ms.
 */
export const highlightElement = (element, highlightColor = 'rgba(59, 130, 246, 0.2)', duration = 1500) => {
  if (!element) return;

  const originalTransition = element.style.transition;
  const originalOutline = element.style.outline;
  const originalOutlineOffset = element.style.outlineOffset;

  element.style.transition = `outline ${duration / 3}ms ease-in-out, outline-offset ${duration / 3}ms ease-in-out`;
  element.style.outline = `2px solid ${highlightColor}`;
  element.style.outlineOffset = '2px';

  setTimeout(() => {
    if (element) { // Verifica se l'elemento esiste ancora
      element.style.outlineOffset = '0px';
      element.style.outline = originalOutline; // Ripristina outline originale
       setTimeout(() => {
           if (element) {
               element.style.transition = originalTransition; // Ripristina transizione originale
               // Non serve ripristinare outlineOffset se outline è ripristinato
           }
       }, duration / 3);
    }
  }, (duration * 2) / 3);
};

export const scrollToElement = (element) => {
  if (element && typeof element.scrollIntoView === 'function') {
    const attemptScroll = (retryCount = 0) => {
      if (element.offsetParent !== null) { // Check if the element is part of the rendered layout
        try {
          element.scrollIntoView({
            behavior: 'smooth', // This enables the smooth scrolling animation
            block: 'center',
            inline: 'nearest'
          });

        } catch (e) {

        }
      } else {
        // Element is not in the layout (e.g., display:none or detached)
        if (retryCount < 3) { // Retry a few times with increasing delay
          const delay = (retryCount + 1) * 50; // e.g., 50ms, 100ms, 150ms

          setTimeout(() => attemptScroll(retryCount + 1), delay);
        } else {

        }
      }
    };

    // Initial attempt, usually after a rAF from the calling useEffect
    attemptScroll();

  } else {
    // Element reference invalid or scrollIntoView not available
  }
};